import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "AddSharedMailboxesAsAccountTeachingCallout" */ "./lazyIndex"), { name: "AddSharedMailboxesAsAccountTeachingCallout" });

export const LazyAddSharedMailboxesAsAccountTeachingCallout: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.AddSharedMailboxesAsAccountTeachingCallout);
